import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 21C2.43333 21 1.95833 20.8083 1.575 20.425C1.19167 20.0417 1 19.575 1 19.025V11C1 10.45 1.196 9.979 1.588 9.587C1.97933 9.19567 2.45 9 3 9C3.56667 9 4.04167 9.19167 4.425 9.575C4.80833 9.95833 5 10.425 5 10.975V19C5 19.55 4.804 20.021 4.412 20.413C4.02067 20.8043 3.55 21 3 21ZM9 21C8.45 21 7.97933 20.8043 7.588 20.413C7.196 20.021 7 19.55 7 19V9C7 8.73333 7.05 8.47933 7.15 8.238C7.25 7.996 7.39167 7.78333 7.575 7.6L13.125 2.05C13.4083 1.76667 13.7583 1.625 14.175 1.625C14.5917 1.625 14.9417 1.76667 15.225 2.05C15.4083 2.23333 15.5377 2.44567 15.613 2.687C15.6877 2.929 15.7 3.175 15.65 3.425L14.7 8H21C21.5333 8 22 8.2 22.4 8.6C22.8 9 23 9.46667 23 10V12C23 12.1167 22.9873 12.2417 22.962 12.375C22.9373 12.5083 22.9 12.6333 22.85 12.75L19.825 19.8C19.6417 20.2 19.3627 20.5 18.988 20.7C18.6127 20.9 18.225 21 17.825 21H9ZM9 19H18L21 12V10H12L13.35 4.65L9 9V19Z",
		fill: "currentColor"
	})
});
export default SvgThumbUp;
